import { useQuery } from '@tanstack/react-query';
import { fetchSolar } from './fetchSolar';
import { fetchMaps } from './fetchMaps';
import { fetchGalleryScenes } from './fetchGalleryScenes';
import fetchSite from './fetchSite';

export default function useAvailableFeatures({ company, sitename }: { company: string; sitename: string }) {
  const siteQuery = useQuery({
    queryKey: ['site', sitename, company],
    queryFn: () => fetchSite(sitename, company),
    enabled: !!sitename && !!company,
  });

  const siteid = siteQuery.data?.[0]?.siteid;

  const solarQuery = useQuery({
    queryKey: ['company', company, 'siteId', siteid, 'solarScenes'],
    queryFn: () => fetchSolar(company, siteid!),
    enabled: !!siteid,
  });

  const mapsQuery = useQuery({
    queryKey: ['company', company, 'siteId', siteid, 'mapScenes'],
    queryFn: () => fetchMaps(company, siteid!),
    enabled: !!siteid,
  });

  const galleryQuery = useQuery({
    queryKey: ['company', company, 'siteId', siteid, 'galleryScenes'],
    queryFn: () => fetchGalleryScenes(company, siteid!),
    enabled: !!siteid,
  });

  return [
    (solarQuery.data?.length ?? 0) > 0,
    (mapsQuery.data?.length ?? 0) > 0,
    (galleryQuery.data?.length ?? 0) > 0,
  ] as [boolean, boolean, boolean];
}
